import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHero from '../components/PageHero';
import { API_URL, getMediaURL } from '../config';

const Services = () => {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [heroData, setHeroData] = useState(null);

  const getServices = async () => {
    try {
      setLoading(true);
      const API_URL_SERVICES = `${API_URL}/api/services?populate=*&sort[0]=order:asc`;
      
      const response = await fetch(API_URL_SERVICES);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      const transformedServices = result.data.map(service => ({
        id: service.id,
        documentId: service.documentId || '',
        title: service.title || '',
        description: service.description || '',
        image: service.image?.url || null,
        order: service.order || 0
      }));
      
      transformedServices.sort((a, b) => a.order - b.order);
      setServices(transformedServices);
      setError(null);
    } catch (error) {
      console.error('Error fetching services:', error);
      setError('Hizmetler yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const getHeroData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/heroes?populate=*`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      console.log('Hero API Response:', result);
      
      if (result.data && result.data[0]) {
        const heroItem = result.data[0];
        console.log('Hero Item:', heroItem);
        console.log('Image URL:', heroItem.image?.url);
        setHeroData({
          title: 'Çalışma Alanları',
          subtitle: 'Uzman Hukuki Danışmanlık Hizmetlerimiz',
          image: heroItem.image?.url ? 
            getMediaURL(heroItem.image.url) : null
        });
        console.log('Final Image URL:', getMediaURL(heroItem.image?.url));
      }
    } catch (error) {
      console.error('Error fetching hero:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await Promise.all([getServices(), getHeroData()]);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      {heroData && (
        <PageHero
          title={heroData.title}
          subtitle={heroData.subtitle}
          image={heroData.image}
        />
      )}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id}
              onClick={() => navigate(`/services/${service.documentId}`)}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              {service.image && (
                <div className="aspect-w-16 aspect-h-9">
                  <img 
                    src={getMediaURL(service.image)}
                    alt={service.title}
                    className="w-full h-64 object-cover transform group-hover:scale-105 transition-transform duration-300"
                    onError={(e) => {
                      console.error('Image load error:', e);
                      e.target.src = 'https://via.placeholder.com/400x300?text=Service+Image';
                    }}
                  />
                </div>
              )}
              <div className="p-8">
                <h2 className="text-2xl font-semibold mb-4 group-hover:text-primary transition-colors">{service.title}</h2>
                <p className="text-gray-600">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
